module.exports = __webpack_public_path__ + "static/media/PrivacyPolicy.df816e1e.pdf";